import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';
import { BookSessionScreen } from '@/features/sessions/components/workspace/BookSessionScreen';

export const Route = createFileRoute('/_staff/admin/workspace/sessions/book')({
  beforeLoad: () => {
    requirePermission('session:create');
  },
  component: BookSessionScreen,
  staticData: { crumb: 'Book session' },
});
